<div id="standard-modal" role="dialog" aria-labelledby="standard-modalLabel">
  <div class="modal-content">

    <div class="modal-header">
      <h4 class="modal-title" id="standard-modalLabel"> {{ 'updatePassword.home.title' | translate }}</h4>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true" (click)="close()"></button>
    </div>

    <div class="modal-body">
      <form [formGroup]="formGroup">
        <div class="mb-3 position-relative">
          <label class="form-label fw-semibold text-dark">{{ 'updatePassword.home.currentPasswordLabel' | translate }}</label>
          <input
            [type]="hideAllPasswords ? 'password' : 'text'"
            class="form-control pe-5"
            formControlName="currentPassword"
            [placeholder]="'updatePassword.home.currentPasswordPlaceholder' | translate"
          />
          <i
            class="bi icon-eye"
            [ngClass]="hideAllPasswords ? 'bi-eye-slash' : 'bi-eye'"
            (click)="togglePasswordVisibility()"
          ></i>
          <field-error-component [field]="'currentPassword'" [label]="'updatePassword.home.currentPasswordErrorLabel' | translate" [formGroup]="formGroup" />
        </div>


        <div class="mb-3 position-relative">
          <label class="form-label fw-semibold text-dark">{{ 'updatePassword.home.newPasswordLabel' | translate }}</label>
          <input
            [type]="hideAllPasswords ? 'password' : 'text'"
            class="form-control pe-5"
            formControlName="newPassword"
            [placeholder]="'updatePassword.home.newPasswordPlaceholder' | translate"
          />
          <i
            class="bi icon-eye"
            [ngClass]="hideAllPasswords ? 'bi-eye-slash' : 'bi-eye'"
            (click)="togglePasswordVisibility()"
          ></i>
          <field-error-component [field]="'newPassword'" [label]="'updatePassword.home.newPasswordErrorLabel' | translate" [formGroup]="formGroup" />
        </div>

        <div class="mb-3 position-relative">
          <label class="form-label fw-semibold text-dark">{{ 'updatePassword.home.confirmPasswordLabel' | translate }}</label>
          <input
            [type]="hideAllPasswords ? 'password' : 'text'"
            class="form-control pe-5"
            formControlName="confirmedPassword"
            [placeholder]="'updatePassword.home.confirmPasswordPlaceholder' | translate"
          />
          <i
            class="bi icon-eye"
            [ngClass]="hideAllPasswords ? 'bi-eye-slash' : 'bi-eye'"
            (click)="togglePasswordVisibility()"
          ></i>
          <field-error-component [field]="'confirmedPassword'" [label]="'updatePassword.home.confirmPasswordErrorLabel' | translate" [formGroup]="formGroup" />
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="close()">
        {{ 'updatePassword.home.cancelButton' | translate }}
      </button>
      <button
        type="submit"
        class="btn btn-primary "
        [mat-dialog-close]="true"
        [disabled]="!formGroup.valid || loading"
        (click)="save()"
      >
        {{ isNew ? ('updatePassword.home.saveButton' | translate) : ('updatePassword.home.changeButton' | translate) }}
        @if (loading) {
          <mat-spinner
            [diameter]="25"
            [color]="'accent'"
            mode="indeterminate"
          />
        }
      </button>
    </div>
  </div>
</div>
